import store from '@/store'
import { log, formatMenu } from '@/utils'
import constantRouterMap from './src'
import routerConfig from './router.config'

//获取当前角色信息 并 获取角色下路由权限
export async function loadRouter () {
  await store.dispatch('getUserInfo').catch((err) => {
    console.log(err)
    return routerConfig.defaultRouter
  })
  return await getPermiss()
}
//获取当前角色对应路由权限
export async function getPermiss () {
  const newRouterList = await store.dispatch('getPermissionInterface').then(() => {
    // 根据权限菜单动态加载路由
    const customRouterUrls = ['/shopiframe', '/test/test']
    const menus = store.getters.menus
    // console.log('menus:', menus)
    menus.forEach((item) => {
      formatMenu(item)
      if (item.subset) {
        item.children = item.subset
        const smenus = item.subset
        smenus.forEach((sitem) => {
          formatMenu(sitem)
          if (sitem.subset) {
            sitem.children = sitem.subset
            const tmenus = sitem.subset
            tmenus.forEach((titem) => {
              customRouterUrls.push(titem.url)
            })
          } else {
            customRouterUrls.push(sitem.url)
          }
        })
      }
    })
    let newRouter = []
    Object.keys(constantRouterMap).forEach((key) => {
      if (constantRouterMap[key].children) {
        const tempRouter = {
          ...constantRouterMap[key],
          children: []
        }
        constantRouterMap[key].children.forEach((sitem) => {
          if (customRouterUrls.indexOf(constantRouterMap[key].path + '/' + sitem.path) > -1) {
            tempRouter.children.push(sitem)
          }
        })
        if (tempRouter.children.length > 0) {
          newRouter.push(tempRouter)
        }
      } else {
        if (customRouterUrls.indexOf(constantRouterMap[key].path) > -1) {
          newRouter.push(constantRouterMap[key])
        }
      }
    })
    //合并前端静态路由
    newRouter = newRouter.concat(routerConfig.defaultRouter)
    // console.log('合并前端静态路由', newRouter)
    return newRouter
  })
  return newRouterList
}
export default {
  loadRouter: loadRouter
}
